import { Injectable } from '@angular/core';

import { BehaviorSubject } from 'rxjs';

import { NotificationItem } from '@shared/models';

@Injectable({
    providedIn: 'root',
})
export class NotificationService {
    public notifications = new BehaviorSubject<NotificationItem[]>([]);

    successMessage(message: string, buttonLabel?: string, buttonUrl?: string) {
        this.notifications.next([...this.notifications.getValue(), new NotificationItem('success', message, buttonLabel, buttonUrl)]);
    }

    errorMessage(message: string, buttonLabel?: string, buttonUrl?: string) {
        this.notifications.next([...this.notifications.getValue(), new NotificationItem('error', message, buttonLabel, buttonUrl)]);
    }

    warningMessage(message: string, buttonLabel?: string, buttonUrl?: string) {
        this.notifications.next([...this.notifications.getValue(), new NotificationItem('warning', message, buttonLabel, buttonUrl)]);
    }

    removeNotification(index: number) {
        this.notifications.getValue().splice(index, 1);
    }

    clearAllNotifications() {
        this.notifications.next([]);
    }
}
